import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PersonFlag } from "@common/ADAPT.Common.Model/person/person-flag.enum";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { lastValueFrom } from "rxjs";
import { PersonFlagService } from "../../person/person-flag.service";

@Component({
    selector: "adapt-dismissible-cta",
    templateUrl: "./dismissible-cta.component.html",
    styleUrls: ["./dismissible-cta.component.scss"],
    standalone: false,
})
export class DismissibleCtaComponent extends BaseComponent implements OnInit {
    @Input() public flag?: PersonFlag;
    @Input() public ctaStyle = 0;
    @Output() public dismissCta = new EventEmitter<boolean>();

    public dismissed = true;
    public ctaImage = "";
    public ctaBackgroundStyle = "";

    public constructor(
        private personFlagService: PersonFlagService,
    ) {
        super();
    }

    public async ngOnInit() {
        this.dismissed = await this.getDismissedStatus();

        this.ctaImage = (this.ctaStyle === 0)
            ? "/content/shell/images/content_header3.png"
            : "/content/shell/images/content_header2.png";


        this.ctaBackgroundStyle = `cta cta-style-${this.ctaStyle}`;
    }

    public dismiss(triggeredByRun: boolean = false) {
        if (this.flag) {
            this.personFlagService.setFlagAndSave(this.flag, true).pipe(
                this.takeUntilDestroyed(),
            ).subscribe((dismissed) => {
                this.dismissed = dismissed;
                this.dismissCta.next(triggeredByRun);
            });
        }
    }

    private async getDismissedStatus() {
        if (!this.flag) {
            return false;
        }

        return lastValueFrom(this.personFlagService.isFlagEnabled(this.flag));
    }
}
